import { Icon, typography } from '@joor/design-system'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 50px;
`

const Header = styled.h2`
  && {
    ${typography.alpha.primaryActive.headline2}
    font-weight: var(--font-weight-light);
    line-height: 50px;
    color: var(--color-primary-800);
    margin: 0;
  }
`

const Subtitle = styled.h4`
  && {
    ${typography.alpha.primaryActive.headline4}
    line-height: 32px;
    color: var(--color-primary-800);
    text-align: center;
    margin: 0;
  }
`

type OrphanOrderViewProps = {
  openModal?: () => void
}

const OrphanOrderView = ({ openModal }: OrphanOrderViewProps) => {
  return (
    <Container>
      <Icon iconName="person" iconSize="extraLarge" />
      <Header>No retailer</Header>
      <Subtitle>
        JOOR Pay cannot be used until a retailer is attached to this order.
        <br />
        <span
          style={{ color: 'var(--color-secondary-800)', cursor: 'pointer' }}
          onClick={openModal}
        >
          Click
        </span>{' '}
        to select retailer.
      </Subtitle>
    </Container>
  )
}

export default OrphanOrderView
